import React from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import HistoryList from "./HistoryList"
import "./HistoryListModal.css"

function HistoryListModal({ isOpen, toggle, title = "History", objectIds = [], emptyText = "No history found yet.", }) {
    const normalizedObjectIds = (objectIds || []).filter(Boolean)

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered className="history-list-modal">
            {/* <ModalHeader toggle={toggle} close={closeButton}>{title}</ModalHeader> */}
            <ModalBody className="history-list-modal__body">
                <div className="history-list-modal__content">
                    <HistoryList
                        objectIds={normalizedObjectIds}
                        emptyText={emptyText}
                    />
                </div>
            </ModalBody>
            <ModalFooter className="history-list-modal__footer">
                <button type="button" className="history-list-modal__close" onClick={toggle} aria-label="Close">
                    CLOSE
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default HistoryListModal
